import { FC, ReactNode, useEffect, useMemo } from 'react';
import { applyRemoteTextOverrides } from '@/i18n';
import { useTranslations } from '@/hooks/fetch-hooks/use-translations';
import { useAuthContext } from '../auth';
import { AuthState } from '../auth/types';
import { TranslationsContext } from './context';
import { ITranslationsContext } from './types';

// ==============================|| TRANSLATIONS PROVIDER ||============================== //
// La inițializarea aplicației (DOAR în context autentificat) aducem din BE bundle-ul de
// texte admin (GET api/translations/bundle — dicționar plat cheie→valoare) și-l aplicăm
// PESTE textele i18n — BE e sursa de adevăr; cheile necunoscute local sunt ignorate. La
// eroare / bundle gol nu se schimbă nimic → rămân textele locale web (fallback).

export const TranslationsProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { authState } = useAuthContext();

	const { bundle, loadingBundle, errorBundle, getBundle } = useTranslations({
		withBundle: true,
		enabled: authState === AuthState.SignedIn
	});

	useEffect(() => {
		applyRemoteTextOverrides(bundle);
	}, [bundle]);

	const value: ITranslationsContext = useMemo(
		() => ({ bundle, loading: loadingBundle, error: errorBundle, refetch: getBundle }),
		[bundle, loadingBundle, errorBundle, getBundle]
	);

	return (
		<TranslationsContext.Provider value={value}>{children}</TranslationsContext.Provider>
	);
};
